import React from "react";
import Accordion from "../../components/Frontend/Accordion";
import PagesTop from "../../components/Frontend/PagesTop";
import HomePageLayout from "../../layouts/HomepageLayout";
import faqBg from "../../styles/bgs/faq-bg.jpg";

const Faq = () => {
  return (
    <HomePageLayout>
      <PagesTop title="FREQUENTLY ASKED QUESTIONS" link="FAQs" bg={faqBg} />
      <div className="faq">
        <div className="faq-body">
          <div className="faq-left">
            <Accordion
              title="What is the Profitability of the program?"
              content="Profitability depends on the investment plan you have chosen. We offer groups of investment plans with different specialization and investment terms."
            />
            <Accordion
              title="Are my profits taxable?"
              content="Taxation generally depends on the tax law governing your country of residence. Therefore,  Capital cannot delegate responsibility with its clients and they must tend to their own tax liabilities."
            />
            <Accordion
              title="What payment systems are used by the company to support the investment process?"
              content="You can make investments using Bitcoin, Etherium and Tether."
            />
            <Accordion
              title="How long will my withdrawal request take to be processed?"
              content="Requests are completed asap, during our working hours its normally completed within several hours but it could take up to 72 hours over weekends."
            />
            <Accordion
              title="Whats the amount limit for withdrawal?"
              content="Requests are completed asap, during our working hours its normally completed within several hours but it could take up to 72 hours over weekend."
            />
            <Accordion
              title="Can I reinvest from my  Capital account balance?"
              content="Yes, you can reinvest from your   Capital account balance after after you've reached the minimum investment value for your selected plan."
            />
            <Accordion
              title="Are there any commisison fees for the investment process or financial transactions?"
              content="There are no commission fees, additional or hidden charges and you can withdraw your earnings at any time from your dashboard."
            />
            <Accordion
              title="How safe are my investments?"
              content="Your money is protected under the Canadian Investor Protection Fund, which insures your money in case of insolvency for up to $1,000,000 per account type."
            />
            <Accordion
              title="Why can't i log into my  Capital account?"
              content="The most common reason for login errors happens when the password is copy-pasted (since there may be spaces before or after the password.) Make sure you type it correctly. An additional reason for login error is when your browser is storing old passwords through cookies. Please clear the cookies through the browser settings and if the problem persists, try entering with a different browser. For further assistance, please contact our support team to help you."
            />
          </div>
          <div className="faq-right">
            <div className="faq-help">
              <h5>Need Any Help?</h5>
              <p>
                Contact us at the Consulting Office nearest to you Or you can
                Contact our Live Support
              </p>
            </div>
          </div>
        </div>
      </div>
    </HomePageLayout>
  );
};

export default Faq;
